var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndeterminateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 2,
    fill: "none",
    viewBox: "0 0 10 2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 1.5,
    x: 0.5,
    y: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndeterminateIcon);
export default __webpack_public_path__ + "static/media/indeterminate-icon.a4a14aa38c65d377fa437ab2b403c4f0.svg";
export { ForwardRef as ReactComponent };